import { useCallback } from 'react';

import { usePutDisbursementPayoutDraftsDraftId } from 'api';

import { useCurrentOrganisation } from 'hooks/context';

import {
  useDraftProgress,
  type DraftStepPayload
} from '../contexts/DraftProgressProvider';
import type { DraftSteps } from '../utils/types';

export const useDraftStepSubmit = (step: DraftSteps) => {
  const { setData, draftId } = useDraftProgress();

  const { mutateAsync: updateDraft } = usePutDisbursementPayoutDraftsDraftId();

  const { id: organisationId } = useCurrentOrganisation();

  const submit = useCallback(
    (payload: DraftStepPayload) => {
      return updateDraft({
        organisationId,
        draftId,
        data: {
          [step]: payload[step]
        }
      }).then(() => {
        setData((prev) => ({
          ...prev,
          ...payload
        }));
      });
    },
    [organisationId, updateDraft, step, setData]
  );

  return submit;
};
